export default "__VITE_ASSET__7833faba__"